import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import { ValidationSummary } from "devextreme-react/validation-summary";
import {
	ExitButton,
	PrintButton,
	PurchaseOrderAddNoteButton,
	PurchaseOrderCards,
	PurchaseOrderFilesButton,
	PurchaseOrderNotesPanel,
	PurchaseOrderPage,
	PurchaseOrderProducts,
	PurchaseOrderProgress,
	PurchaseOrderProgressStep,
	SaveButton,
	ValidateDeliveryDatePanel
} from '../../../features/distributor/purchase-order';
import '../../../css/order.scss';

export default function PurchaseOrderValidateDeliveryPage() {

	return (

		<PurchaseOrderPage>

			<PurchaseOrderCards />

			<PurchaseOrderProgress />

			<ValidationSummary />

			<Toolbar className='button-toolbar'>
				<ToolbarItem location={'before'}>
					<SaveButton step={PurchaseOrderProgressStep.ValidateDelivery} />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<PrintButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<PurchaseOrderFilesButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<ExitButton />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<PurchaseOrderAddNoteButton />
				</ToolbarItem>
			</Toolbar>

			<Box>
				<Item ratio={1}>
					<ValidateDeliveryDatePanel />
				</Item>
				<Item ratio={1}>
					<PurchaseOrderNotesPanel height={200} />
				</Item>
			</Box>

			<PurchaseOrderProducts />

		</PurchaseOrderPage>
	)
}
